//own imports
import './Expenses.css';
import LoadingGif from '../../../images/LoadingGif.gif';
//imports react
import React, {
    useEffect,
    useRef,
    useState,
} from 'react';
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import {
    useParams, Link, 
} from "react-router-dom";
import Chart from "react-google-charts";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

//firebase imports
import { collection, query, where, getDocs, getDoc, doc, limit, orderBy, arrayRemove, updateDoc,  Timestamp } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";


const db = getFirestore();
const auth = getAuth();

const Expenses = () => {

    //Popup opening from code
    const ref = useRef();
    const openModal = () => ref.current.open();

    const refDeleteExpense = useRef();
    const openModalDeleteExpense = () => refDeleteExpense.current.open();

    const refAllExpenses = useRef();
    const openModalAllExpenses = () => refAllExpenses.current.open();
   
    const [expenses, setExpenses] = useState([]);
    const [allExpenses, setAllExpenses] = useState([]);
    const [group, setGroup] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [currentUserPermissions, setCurrentUserPermissions] = useState(null);
    const [tenExpense, setTenExpenses] = useState([]);
    //filters
    const [members, setMembers] = useState([]);
    const [categories, setCategories] = useState([]);
    //


    //chart
    const [chartData, setChartData] = useState([]);
    //events
    const [events, setEvents] = useState([]);
    let evenstAlreadyRetrieved = false;

    //retrieving params from url
    const {groupId} = useParams();

    //Page title
    useEffect(() => {
        document.title = 'Expenses';

        onAuthStateChanged(auth, (user) => {
            if (user !== null) {
                getCurrentUser();
            }
        });

        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    if (currentUserPermissions === null) {
        return (
            <div className='topContainer'>
            <div style={{ minHeight: '100vh', maxWidth: '1250px', width: '100%'}}>
               <h1 className="header">Expenses</h1>
               <p className='errorMessage expensesMainErrorMessage'></p>
                    <div className="kpiBox">
                        <div className="kpiAllTime kpiBoxItem" style={{ width: '87%' }}>
                            <p className='spentText'>Spent all time</p>
                            <div className="kpiAllTimeValue"></div>
                        </div>
                    </div>
               <div className="kpiBox">
                   <div className="kpiWeek kpiBoxItem">
                        <p className='spentText'>Spent this week</p>
                       <div className="kpiWeekValue"></div>
                   </div>
                   <div className="kpiMonth kpiBoxItem">
                        <p className='spentText'>Spent this month</p>
                       <div className="kpiMonthValue"></div>
                   </div>
               </div>
               <div className="graphBox" >
                   <Chart className="graphExpenses"
                       chartType="Bar"
                       loader={<div className="loadingGif"><img src={LoadingGif} alt="loading" /></div>}
                       data={chartData}
                       options={{
                           legend: { position: 'none' },
                           // Material design options
                           chart: {
                               title: 'Total Spent a Month',
                           },
                           chartArea: {
                               backgroundColor: 'green',
                           },
                           backgroundColor: '#f1f8e9',
                           padding: '1rem'
                       }}
                   />
               </div>
               <div className="listTenExpenses">
                   <p className='lastTen'>Last 10 Transactions</p> <br />
                   {expenses.map((expense, index) => {
                       return (
                           <div className="expenseItem" onClick={() => goToDetailPageExpense(expense)} key={index}>
                               <div className="expenseItemLeft">
                                   {
                                       expense.category === "Food" ? <FaIcons.FaUtensils className="expenseItemIcon" color="green" size="24" /> :
                                           expense.category === "Transport" ? <FaIcons.FaBus className="expenseItemIcon" color="yellow" size="24" /> :
                                               expense.category === "Recreation" ? <AiIcons.AiFillPlayCircle className="expenseItemIcon" color="blue" size="24" /> :
                                                   expense.category === "Clothes" ? <FaIcons.FaCartPlus className="expenseItemIcon" color="red" size="24" /> :
                                                       expense.category === "Housing" ? <FaIcons.FaHome className="expenseItemIcon" color="orange" size="24" /> :
                                                           expense.category === "Ensurance" ? <FaIcons.FaBook className="expenseItemIcon" color="brown" size="24" /> :
                                                               <FaIcons.FaCircle className="expenseItemIcon" color="black" size="24" />
                                   }
                               </div>
                               <div className="expenseItemMiddle">
                                   <p>{expense.name}</p>
                                   <p>{expense.date}</p>
                               </div>
                               <div className="expenseItemRight">
                                   <p>&euro;{expense.price}</p>
                               </div>
                           </div>
                       )
                   })}
               </div>
                <div className='filtersMainBox'><p className='filteringText'>Filtering</p><div className="filterExpenses">
                    <div className="personfilter filterExpensesItem">
                        {members.map((member, index) => {
                            if (member.selected) {
                                return (
                                    <div onClick={() => { executeFilter(member.id, null, allExpenses); selectClickedMember(member) }} className="memberSelectedItem" key={index}>
                                        <p>{member.value}</p>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div onClick={() => { executeFilter(member.id, null, allExpenses); selectClickedMember(member) }} className="memberItem" key={index}>
                                        <p>{member.value}</p>
                                    </div>
                                )
                            }
                        })}
                    </div>
                    <div className="cateFiltrer filterExpensesItem">
                        {categories.map((category, index) => {
                            if (category.selected) {
                                return (
                                    <div onClick={() => { executeFilter(null, category.label, allExpenses); selectClickedCategory(category) }} className="categorySelectedItem" key={index}>
                                        <p>{category.label}</p>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div onClick={() => { executeFilter(null, category.label, allExpenses); selectClickedCategory(category) }} className="categoryItem" key={index}>
                                        <p>{category.label}</p>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </div>
                    <button className='btn-secondary resetBtn' onClick={resetFilter}>Reset Filter</button>
                </div>
               <div className="btnExpensesBox">
                   <Link to={"/createEditGroup/" + groupId}><button className="btn-primary" >Edit Group</button></Link>
                   <Link to={'/managePeople/' + groupId}><button className="btn-secondary" >Manage Members</button></Link>

                   <Popup trigger={<button className="btn-danger">Leave Group</button>} position="center" modal>
                       {close => (
                           <div className="popUpExpenses">
                               <div className="popUpDeleteGroup_header">Are you sure to leave this group</div>
                               <div className="popUpLeave_content">
                                   <p className="errorMessage errorLeaveGroupMessage"></p>
                               </div>
                               <div className="popUpLeave_actions">
                                   <button className="btn-secondary btnLeave btnCancel" onClick={() => { close(); }}>Cancel</button>
                                   <button className="btn-danger btnLeave" onClick={leaveGroup}>Leave Group</button>
                               </div>
                           </div>
                       )}
                   </Popup>
               </div>
               <Fab 
               icon={<FaIcons.FaChartBar></FaIcons.FaChartBar>} 
               mainButtonStyles={{ backgroundColor: '#027B93' }} 
               style={{ bottom: 12, right: 12, }}
               >
                   <Action
                       text={"Insert Expense"}
                       onClick={goToInsertExpensePage}
                       children={<FaIcons.FaPlus></FaIcons.FaPlus>}
                       style={{ backgroundColor: 'crimson' }}
                   />
                        <Action
                            text="Watch all expenses"
                            onClick={() => { closeFab(); openModalAllExpenses(); }}
                            children={<FaIcons.FaEye></FaIcons.FaEye>}
                            style={{ backgroundColor: 'crimson' }}
                        >
                        </Action>
                        <Action
                            text="All events"
                            onClick={() => {closeFab(); openModal()}}
                            children={<FaIcons.FaList></FaIcons.FaList>}
                            style={{ backgroundColor: 'crimson' }}
                        >
                        </Action>
               </Fab>
           </div>
                <Popup ref={refAllExpenses}
                    position="center" modal>
                    {close => (
                        <div className="popUpExpenses">
                            <div className="popUpDeleteGroup_header"> All Group Expenses </div>
                            <div className="popUpExpenses_content">
                                {allExpenses.map((expense, index) => {
                                    return (
                                        <div className="expenseItem" key={index} onClick={() => goToDetailPageExpense(expense)} >
                                            <div className="expenseItemLeft">
                                                {
                                                    expense.category === "Food" ? <FaIcons.FaUtensils className="expenseItemIcon" color="green" size="24" /> :
                                                        expense.category === "Transport" ? <FaIcons.FaBus className="expenseItemIcon" color="yellow" size="24" /> :
                                                            expense.category === "Recreation" ? <AiIcons.AiFillPlayCircle className="expenseItemIcon" color="blue" size="24" /> :
                                                                expense.category === "Clothes" ? <FaIcons.FaCartPlus className="expenseItemIcon" color="red" size="24" /> :
                                                                    expense.category === "Housing" ? <FaIcons.FaHome className="expenseItemIcon" color="orange" size="24" /> :
                                                                        expense.category === "Ensurance" ? <FaIcons.FaBook className="expenseItemIcon" color="brown" size="24" /> :
                                                                            <FaIcons.FaCircle className="expenseItemIcon" color="black" size="24" />
                                                }
                                            </div>
                                            <div className="expenseItemMiddle">
                                                <p>{expense.name}</p>
                                                <p>{expense.date}</p>
                                            </div>
                                            <div className="expenseItemRight">
                                                <p>&euro;{expense.price}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="popUpExpenses_actions">
                                <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Close</button>
                            </div>
                        </div>
                    )}
                </Popup>
                <Popup ref={ref} position="center" modal>
                    {close => (
                        <div className="popUpExpenses">
                            <div className="popUpDeleteGroup_header">All Group Events</div>
                            <div className="popUpExpenses_content">
                                {events.map((event, index) => {
                                    return (
                                        <div className="expenseItem" key={index}>
                                            {               //if undefiened, then it is a expense event else an memeber event
                                                event.id === undefined ?
                                                    <div className="expenseEvent">
                                                        <div className="expenseItemMiddle eventSubItem">
                                                            {
                                                                event.isNewestVersion === true ? <div className="eventLine"><p><FaIcons.FaCheckCircle style={{ marginRight: '10px', padding: '0', marginBottom: '-2px' }} className="expenseItemIcon" color="green" size="16"></FaIcons.FaCheckCircle>Expense <strong>{event.name}</strong> was added to this group on <strong>{event.date}</strong>. It's cost is <strong>&euro;{event.price}</strong></p>
                                                                </div>
                                                                    :
                                                                    <p>Expense <strong>{event.name}</strong> was updated on <strong>{event.updatedDate}</strong>. It's cost was <strong>&euro;{event.price}</strong></p>
                                                            }
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="expenseItemMiddle eventSubItem">
                                                        {new Date(event.membership) < new Date() ? <p><strong>{event.name}</strong> has <strong>left</strong> this group on <strong>{event.membership}</strong></p> : <p><strong>{event.name}</strong> has <strong>entered</strong> this group on <strong>{event.enteredGroup}</strong></p>}
                                                    </div>
                                            }
                                        </div>
                                    );
                                })}</div>
                            <div className="popUpExpenses_actions">
                                <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                            </div>
                        </div>
                    )}
                </Popup>
            </div>
       );
    } else{
       return (
            <div className='topContainer' >
               <div style={{ minHeight: '100vh', maxWidth:'1250px', width:'100%' }}>
                   <h1 className="header">Expenses</h1>
                   <p className='errorMessage expensesMainErrorMessage'></p>
                   <div className="kpiBox">
                       <div className="kpiAllTime kpiBoxItem" style={{width:'87%'}}>
                           <p className='spentText'>Spent all time</p>
                           <div className="kpiAllTimeValue"></div>
                       </div>
                   </div>
                   <div className="kpiBox">
                       <div className="kpiWeek kpiBoxItem">
                           <p className='spentText'>Spent this week</p>
                           <div className="kpiWeekValue"></div>
                       </div>
                       <div className="kpiMonth kpiBoxItem">
                           <p className='spentText'>Spent this month</p>
                           <div className="kpiMonthValue"></div>
                       </div>
                   </div>
                   <div className="graphBox" >
                       <Chart className="graphExpenses"
                           chartType="Bar"
                           loader={<div className="loadingGif"><img src={LoadingGif} alt="loading" /></div>}
                           data={chartData}
                           options={{
                               legend: { position: 'none' },
                               // Material design options
                               chart: {
                                   title: 'Total Spent a Month',
                               },
                               chartArea: {
                                   backgroundColor: 'green',
                               },
                               backgroundColor: '#f1f8e9',
                               padding: '1rem'
                           }}
                       />
                   </div>
                   <div className="listTenExpenses">
                       <p className='lastTen'>Last 10 Transactions</p> <br />
                       {expenses.map((expense, index) => {
                           return (
                               <div key={index}>
                                   {
                                       currentUserPermissions[0].EditRemoveOtherTheirExpenses === true || expense.owner === currentUser.uid ?
                                           <div className="expenseItem" key={index} onClick={(e) => goToDetailPageExpense(expense, e)} >
                                               <div className="expenseItemLeft"  >
                                                   {
                                                       expense.category === "Food" ? <FaIcons.FaUtensils className="expenseItemIcon" color="green" size="24" /> :
                                                           expense.category === "Transport" ? <FaIcons.FaBus className="expenseItemIcon" color="yellow" size="24" /> :
                                                               expense.category === "Recreation" ? <AiIcons.AiFillPlayCircle className="expenseItemIcon" color="blue" size="24" /> :
                                                                   expense.category === "Clothes" ? <FaIcons.FaCartPlus className="expenseItemIcon" color="red" size="24" /> :
                                                                       expense.category === "Housing" ? <FaIcons.FaHome className="expenseItemIcon" color="orange" size="24" /> :
                                                                           expense.category === "Ensurance" ? <FaIcons.FaBook className="expenseItemIcon" color="brown" size="24" /> :
                                                                               <FaIcons.FaCircle className="expenseItemIcon" color="black" size="24" />
                                                   }
                                               </div>
                                               <div className="expenseItemMiddle" >
                                                   <p>{expense.name}</p>
                                                   <p>{expense.date}</p>
                                               </div>
                                               <div className="expenseItemRight" >
                                                   <p>&euro;{expense.price}</p>
                                               </div>
                                               <div className='expenseEditIcon' >
                                                   <FaIcons.FaEdit className='expenseEditIcon' size={18} onClick={() => expenseItemOnClick(expense.key)} ></FaIcons.FaEdit>
                                               </div>
                                           </div>
                                           :
                                           <div className="expenseItem" key={index} onClick={() => goToDetailPageExpense(expense)} >
                                               <div className="expenseItemLeft">
                                                   {
                                                       expense.category === "Food" ? <FaIcons.FaUtensils className="expenseItemIcon" color="green" size="24" /> :
                                                           expense.category === "Transport" ? <FaIcons.FaBus className="expenseItemIcon" color="yellow" size="24" /> :
                                                               expense.category === "Recreation" ? <AiIcons.AiFillPlayCircle className="expenseItemIcon" color="blue" size="24" /> :
                                                                   expense.category === "Clothes" ? <FaIcons.FaCartPlus className="expenseItemIcon" color="red" size="24" /> :
                                                                       expense.category === "Housing" ? <FaIcons.FaHome className="expenseItemIcon" color="orange" size="24" /> :
                                                                           expense.category === "Ensurance" ? <FaIcons.FaBook className="expenseItemIcon" color="brown" size="24" /> :
                                                                               <FaIcons.FaCircle className="expenseItemIcon" color="black" size="24" />
                                                   }
                                               </div>
                                               <div className="expenseItemMiddle">
                                                   <p>{expense.name}</p>
                                                   <p>{expense.date}</p>
                                               </div>
                                               <div className="expenseItemRight">
                                                   <p>&euro;{expense.price}</p>
                                               </div>
                                           </div>
                                   }
                               </div>
                           )
                       })}
                   </div>
                   <div className='filtersMainBox'><p className='filteringText'>Filtering</p><div className="filterExpenses">
                       <div className="personfilter filterExpensesItem">
                           {members.map((member, index) => {
                               if (member.selected) {
                                   return (
                                       <div onClick={() => { executeFilter(member.id, null, allExpenses); selectClickedMember(member) }} className="memberSelectedItem" key={index}>
                                           <p>{member.value}</p>
                                       </div>
                                   )
                               }
                               else {
                                   return (
                                       <div onClick={() => { executeFilter(member.id, null, allExpenses); selectClickedMember(member) }} className="memberItem" key={index}>
                                           <p>{member.value}</p>
                                       </div>
                                   )
                               }
                           })}
                       </div>
                       <div className="cateFiltrer filterExpensesItem">
                           {categories.map((category, index) => {
                               if (category.selected) {
                                   return (
                                       <div onClick={() => { executeFilter(null, category.label, allExpenses); selectClickedCategory(category) }} className="categorySelectedItem" key={index}>
                                           <p>{category.label}</p>
                                       </div>
                                   )
                               }
                               else {
                                   return (
                                       <div onClick={() => { executeFilter(null, category.label, allExpenses); selectClickedCategory(category) }} className="categoryItem" key={index}>
                                           <p>{category.label}</p>
                                       </div>
                                   )
                               }
                           })}
                       </div>
                   </div>
                       <button className='btn-secondary resetBtn' onClick={resetFilter}>Reset Filter</button>
                   </div>
                   <div className="btnExpensesBox">
                       <Link to={"/createEditGroup/" + groupId}><button className="btn-primary" >Edit Group</button></Link>
                       <Link to={'/managePeople/' + groupId}><button className="btn-secondary" >Manage Members</button></Link>
                       <Popup trigger={<button className="btn-danger">Leave Group</button>} position="center" modal>
                           {close => (
                               <div className="popUpExpenses">
                                   <div className="popUpDeleteGroup_header">Are you sure to leave this group</div>
                                   <div className="popUpLeave_content">
                                       <p className="errorMessage errorLeaveGroupMessage"></p>
                                   </div>
                                   <div className="popUpLeave_actions">
                                       <button className="btn-secondary btnLeave btnCancel" onClick={() => { close(); }}>Cancel</button>
                                       <button className="btn-danger btnLeave" onClick={leaveGroup}>Leave Group</button>
                                   </div>
                               </div>
                           )}
                       </Popup>
                   </div>
                   <Fab icon={<FaIcons.FaChartBar></FaIcons.FaChartBar>} mainButtonStyles={{ backgroundColor: '#027B93' }} style={{ bottom: 12, right: 12, }}>
                       <Action
                           text={"Insert Expense"}
                           onClick={goToInsertExpensePage}
                           children={<FaIcons.FaPlus></FaIcons.FaPlus>}
                           style={{ backgroundColor: 'crimson' }}
                       />
                       <Action
                           text="Watch all expenses"
                           onClick={() => { closeFab(); openModalAllExpenses() }}
                           children={<FaIcons.FaEye></FaIcons.FaEye>}
                           style={{ backgroundColor: 'crimson' }}
                       >
                       </Action>              
                       <Action
                           text="All events"
                           children={<FaIcons.FaList></FaIcons.FaList>}
                           style={{ backgroundColor: 'crimson' }}
                           onClick={() => { closeFab(); openModal(); }}
                       >
                       </Action>
                       {
                           currentUserPermissions[0].CreateRemoveGroupCategories === true ?
                               <Action
                                   text="Delete Categories"
                                   onClick={() => {closeFab(); openModalDeleteExpense();}}
                                   children={<FaIcons.FaTrash></FaIcons.FaTrash>}
                                   style={{ backgroundColor: 'red' }}
                               >
                               </Action>
                                :
                               <div></div>
                       }
                   </Fab>
               </div>
               <Popup ref={ref} text="All events" onClick={closeFab} position="center" modal>
                   {close => (
                       <div className="popUpExpenses">
                           <div className="popUpDeleteGroup_header">All Group Events</div>
                           <div className="popUpExpenses_content">
                               {events.map((event, index) => {
                                   return (
                                       <div className="expenseItem" key={index}>
                                           {               //if undefiened, then it is a expense event else an memeber event
                                               event.id === undefined ?
                                                   <div className="expenseEvent">
                                                       <div className="expenseItemMiddle eventSubItem">
                                                           {
                                                               event.isNewestVersion === true ? <div className="eventLine"><p><FaIcons.FaCheckCircle style={{ marginRight: '10px', padding: '0', marginBottom: '-2px' }} className="expenseItemIcon" color="green" size="16"></FaIcons.FaCheckCircle>Expense <strong>{event.name}</strong> was added to this group on <strong>{event.date}</strong>. It's cost is <strong>&euro;{event.price}</strong></p>
                                                               </div>
                                                                   :
                                                                   <p>Expense <strong>{event.name}</strong> was updated on <strong>{event.updatedDate}</strong>. It's cost was <strong>&euro;{event.price}</strong></p>
                                                           }
                                                       </div>
                                                   </div>
                                                   :
                                                   <div className="expenseItemMiddle eventSubItem">
                                                       {new Date(event.membership) < new Date() ? <p><strong>{event.name}</strong> has <strong>left</strong> this group on <strong>{event.membership}</strong></p> : <p><strong>{event.name}</strong> has <strong>entered</strong> this group on <strong>{event.enteredGroup}</strong></p>}
                                                   </div>
                                           }
                                       </div>
                                   );
                               })}</div>
                           <div className="popUpExpenses_actions">
                               <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                           </div>
                       </div>
                   )}
               </Popup>
               <Popup ref={refDeleteExpense}  position="center" modal>
                   {close => (
                       <div className="popUpExpenses">
                           <div className="popUpDeleteGroup_header">Delete Categories</div>
                           <div className="popUpExpenses_content">
                               <p className="errorMessage errorMessageCatDel"></p>
                               {categories.map((categorie, index) => {
                                   return (
                                       <div className="expenseItem" key={index}>
                                           <div className="expenseItemLeft">{categorie.label}</div>
                                           <div className="expenseItemRight"><FaIcons.FaTrash onClick={() => deleteCategory(categorie.label)}></FaIcons.FaTrash></div>
                                       </div>
                                   );
                               })}</div>
                           <div className="popUpExpenses_actions">
                               <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                           </div>
                       </div>
                   )}
               </Popup>
               <Popup ref={refAllExpenses}
                   position="center" modal>
                   {close => (
                       <div className="popUpExpenses">
                           <div className="popUpDeleteGroup_header"> All Group Expenses </div>
                           <div className="popUpExpenses_content">
                               {allExpenses.map((expense, index) => {
                                   return (
                                       <div key={index}>
                                           {
                                               currentUserPermissions[0].EditRemoveOtherTheirExpenses === true || expense.owner === currentUser.uid ?
                                                   <div className="expenseItem" key={index} onClick={() => goToDetailPageExpense(expense)}>
                                                       <div className="expenseItemLeft">
                                                           {
                                                               expense.category === "Food" ? <FaIcons.FaUtensils className="expenseItemIcon" color="green" size="24" /> :
                                                                   expense.category === "Transport" ? <FaIcons.FaBus className="expenseItemIcon" color="yellow" size="24" /> :
                                                                       expense.category === "Recreation" ? <AiIcons.AiFillPlayCircle className="expenseItemIcon" color="blue" size="24" /> :
                                                                           expense.category === "Clothes" ? <FaIcons.FaCartPlus className="expenseItemIcon" color="red" size="24" /> :
                                                                               expense.category === "Housing" ? <FaIcons.FaHome className="expenseItemIcon" color="orange" size="24" /> :
                                                                                   expense.category === "Ensurance" ? <FaIcons.FaBook className="expenseItemIcon" color="brown" size="24" /> :
                                                                                       <FaIcons.FaCircle className="expenseItemIcon" color="black" size="24" />
                                                           }
                                                       </div>
                                                       <div className="expenseItemMiddle">
                                                           <p>{expense.name}</p>
                                                           <p>{expense.date}</p>
                                                       </div>
                                                       <div className="expenseItemRight">
                                                           <p>&euro;{expense.price}</p>
                                                       </div>
                                                       <div className='expenseEditIcon' >
                                                               <FaIcons.FaEdit className='expenseEditIcon' size={18} onClick={() => expenseItemOnClick(expense.key)} ></FaIcons.FaEdit>
                                                       </div>
                                                   </div>
                                                   :
                                                   <div className="expenseItem" key={index} onClick={() => goToDetailPageExpense(expense)}>
                                                       <div className="expenseItemLeft" key={index}>
                                                           {
                                                               expense.category === "Food" ? <FaIcons.FaUtensils className="expenseItemIcon" color="green" size="24" key={index}/> :
                                                                   expense.category === "Transport" ? <FaIcons.FaBus className="expenseItemIcon" color="yellow" size="24" key={index}/> :
                                                                       expense.category === "Recreation" ? <AiIcons.AiFillPlayCircle className="expenseItemIcon" color="blue" size="24" key={index} /> :
                                                                           expense.category === "Clothes" ? <FaIcons.FaCartPlus className="expenseItemIcon" color="red" size="24" key={index}/> :
                                                                               expense.category === "Housing" ? <FaIcons.FaHome className="expenseItemIcon" color="orange" size="24" key={index}/> :
                                                                                   expense.category === "Ensurance" ? <FaIcons.FaBook className="expenseItemIcon" color="brown" size="24" key={index}/> :
                                                                                       <FaIcons.FaCircle className="expenseItemIcon" color="black" size="24" />
                                                           }
                                                       </div>
                                                       <div className="expenseItemMiddle" key={index}>
                                                           <p>{expense.name}</p>
                                                           <p>{expense.date}</p>
                                                       </div>
                                                       <div className="expenseItemRight" key={index}>
                                                           <p>&euro;{expense.price}</p>
                                                       </div>
                                                   </div>
                                           }
                                       </div>
                                   );
                               })}
                           </div>
                           <div className="popUpExpenses_actions">
                               <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Close</button>
                           </div>
                       </div>
                   )}
               </Popup>
            </div>
       );
    }


    async function writeLastVisitedGroupToUser(userId){
        try {
            const userDocs = query(collection(db, "Users"), where('userId', '==', userId));
            const userDocsSnapshot = await getDocs(userDocs);
            let docKey;
            userDocsSnapshot.forEach(doc => {
                docKey = doc.id;
            });

            await updateDoc(doc(db, "Users", docKey), { lastVisitedGroup: groupId });
        } catch (error) {
            document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML = "Somethong went wrong updating last visited group: " + error;
        }
    }

   function closeFab(){
       document.getElementsByClassName('rtf')[0].classList.remove('open');
       document.getElementsByClassName('rtf')[0].classList.add('remove');
   }

   function goToDetailPageExpense (expense, e){
       if (e !== null && e !== undefined) {
           if (e.target.className === "expenseEditIcon" || e.target.parentNode.className === "expenseEditIcon" || e.target.parentNode.parentNode.className === "expenseEditIcon") {
               expenseItemOnClick(expense.key);
               return;
           }
       }
          

       window.location.href = "/expenseDetail/" + groupId + "/" + expense.key;
   }


    async function leaveGroup() {
        const errorMessage = document.querySelector('.errorLeaveGroupMessage');
        //kan de group niet verlaten als owner -> ownership doorgeven? of als enige admin
        let canLeaveGroup = true;
        let onlyAdmin = false;

        if (group.owner === currentUser.uid) {
            canLeaveGroup = false;
        }
        let teller =0;
        group.admins.forEach(admin => {
            teller++;
            if (admin === currentUser.uid ) {
                canLeaveGroup = false;
            }
        });
        if (teller > 1) {
            onlyAdmin = false;
        }
        else{
            onlyAdmin = true;
        }

        if(canLeaveGroup){
           if (onlyAdmin) {
               errorMessage.innerHTML = "You are the only admin of this group. You can't leave the group.";
           }
           else{
               try {
                   let docId = null;

                   const memberDocs = await query(collection(db, "Groups", groupId, "Members"), where("uid", "==", currentUser.uid));
                   const memberDocSnapshot = await getDocs(memberDocs);
                   memberDocSnapshot.forEach((doc) => {
                       docId = doc.id;
                   });

                   //zoeken naar uid in de memberIds van de groep
                   await updateDoc(doc(db, "Groups", groupId), { members: arrayRemove(currentUser.uid) });

                   await updateDoc(doc(db, "Groups", groupId, "Members", docId),{
                          membership: Timestamp.fromDate(new Date()),
                   }).then(() => {
                       window.location.href = "/groups";
                   });
               } catch (error) {
                   errorMessage.innerHTML = error.message;
               }
           }
        }
        else {
            errorMessage.innerHTML = "You can't leave this group, you are the owner of this group";
        }
    }
    
    async function deleteCategory(categoryName){
        //true when no expenses have this category && when not an default category.
        let canDelete = true;
        if(categoryName === "Food" && categoryName === "Transport" && categoryName === "Recreation" && categoryName === "Clothes" && categoryName === "Housing" && categoryName === "Ensurance"){
            canDelete = false;
        }
        else{
            allExpenses.forEach(expense => {
                if(expense.category === categoryName){
                    canDelete = false;
                }
            });
        }
        if(canDelete){
            document.getElementsByClassName("errorMessageCatDel")[0].innerHTML = "";
            try {
                await updateDoc(doc(db, "Groups", groupId), {
                    categories: arrayRemove(categoryName),
                });
                window.location.reload();
            } catch (e) {
                document.getElementsByClassName("errorMessageCatDel")[0].innerHTML = "Error deleting category to group: "+ e;
            }
        }
        else{

            document.getElementsByClassName("errorMessageCatDel")[0].innerHTML = "Cannot delete category, because it is used in an expense or is a default category";
        }
    }

    function getChartData(expensesChart) {
        let data = new Array(13);
        data[0] = ["Month", "Expenses"]
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
       try {
           for (let i = 1; i < data.length; i++) {
               data[i] = [months[i - 1], 0];
           }
           expensesChart.forEach(expense => {
               let date = new Date(expense.date);

               data[date.getMonth() + 1][1] = (parseInt(data[date.getMonth() + 1][1]) + parseInt(expense.price));
           });
           if (data.length > 0) {
               setChartData(data);
           }
       } catch (error) {
           document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML = "Something went wronf filling up the chart: " + error;
       }
    }

    async function getCurrentUser() {
        if (auth.currentUser !== null) {
            setCurrentUser(auth.currentUser);
            getGroupExpenses(groupId, auth.currentUser.uid);
            await writeLastVisitedGroupToUser(auth.currentUser.uid);
        }
    }

    function goToInsertExpensePage() {
        window.location.href = `/insertExpense/${groupId}/${null}`;
    }

    function selectClickedMember(member) {
       
    }

    async function getFilters(expensesAll, currenUserId){

            const getMembersFromFirebase = [];
            const getCategoriesFromFirebase = [];


            try {
                const q = doc(db, "/DefaultCategories", "defaultCategories");

                const docSnap = await getDoc(q);
                if (docSnap.exists()) {
                    getCategoriesFromFirebase.push({ key: docSnap.data().housing, label: docSnap.data().housing }, { key: docSnap.data().food, label: docSnap.data().food, }, { key: docSnap.data().transport, label: docSnap.data().transport, }, { key: docSnap.data().ensurance, label: docSnap.data().ensurance, }, { key: docSnap.data().clothes, label: docSnap.data().clothes, }, { key: docSnap.data().housing, label: docSnap.data().recreation, });

                    if (groupId !== null) {
                        const q = doc(db, "/Groups", groupId);
                        const docSnap = await getDoc(q);
                        if (docSnap.exists()) {
                            docSnap.data().categories.forEach(element => {
                                getCategoriesFromFirebase.push({ value: element, label: element, selected: false });
                            });
                        }
                        else {
                            document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML = "No such group!";
                        }
                    }
                }
                else {
                    // doc.data() will be undefined in this case
                    document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML  = "No categeries found! Try again";
                }
            } catch (error) {
                document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML = "No categeries found! Try again:" + error;
            }

            const members = [];
            
            try {
                const queryGroup = query(collection(db, "/Groups", groupId, "Members"));
                const queryGroupSnapshot = await getDocs(queryGroup);
                queryGroupSnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    members.push({ ...doc.data(), membership: new Date(doc.data().membership.seconds * 1000), enteredGroup: new Date(doc.data().enteredGroup.seconds * 1000) });
                });

                for (let index = 0; index < members.length; index++) {
                    const element = members[index];
                    const queryMemberName = query(collection(db, "/Users"), where("userId", "==", element.uid));
                    const queryMemberNameSnapshot = await getDocs(queryMemberName);

                    if (element.uid === currenUserId) {
                        setCurrentUserPermissions(element.permissions);
                    }
                    queryMemberNameSnapshot.forEach((doc2) => {
                        getMembersFromFirebase.push({ id: element.uid, value: doc2.data().userName, name: doc2.data().userName, enteredGroup: element.enteredGroup, membership: element.membership, selected: false, permissions: element.permissions });
                    });
                }
            } catch (error) {
                document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML = "Something went wrong getting members: " + error;
            }

            setMembers(getMembersFromFirebase);
            setCategories(getCategoriesFromFirebase);

        getAllEventsFromGroup(getMembersFromFirebase, expensesAll);
    }

    function calculateSpentWeekAndMonth(expenses) {
        const kpiWeek = document.getElementsByClassName('kpiWeekValue')[0];
        const kpiMonth = document.getElementsByClassName('kpiMonthValue')[0];
        const kpiAllTime = document.getElementsByClassName('kpiAllTimeValue')[0];

        let spentWeek = 0.0;
        let spentMonth = 0.0;
        let spentAllTime = 0.0;

        expenses.forEach(expense => {
            spentAllTime += parseFloat(expense.price);
        })

        expenses.length = 10;
        
        const today = new Date();
        expenses.forEach(expense => {
            const date = new Date(expense.date);

            if (date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()) {
                spentMonth += parseFloat(expense.price);
            }

            if (date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear() && date.getDate() >= today.getDate() - 7) {
                spentWeek += parseFloat(expense.price);
            }
        });

      try {
          kpiWeek.innerHTML = `\u20AC ${spentWeek}`;
          kpiMonth.innerHTML = `\u20AC ${spentMonth}`;
          kpiAllTime.innerHTML = `\u20AC ${spentAllTime}`;
      } catch (error) {
          
      }
    }

    async function getAllEventsFromGroup(getMembersFromFirebase, expensesAll){
       try {
           if (!evenstAlreadyRetrieved) {
               const eventsArray = [];

               expensesAll.forEach(expense => {
                   eventsArray.push({ ...expense, isNewestVersion: true });
               });

               for (let index = 0; index < expensesAll.length; index++) {
                   const element = expensesAll[index];
                   const queryHistory = query(collection(db, "Groups", groupId, "Expenses", element.key, "History"));
                   const queryHistorySnapshot = await getDocs(queryHistory);
                   queryHistorySnapshot.forEach((doc) => {
                       eventsArray.push({ name: doc.data().name, updatedDate: element.date, date: new Date(doc.data().date.seconds * 1000).toDateString(), price: doc.data().price, isNewestVersion: false });
                   });
               }

               getMembersFromFirebase.forEach(member => {
                   eventsArray.push({ ...member, membership: new Date("1/1/2200"), date: member.enteredGroup.toDateString(), enteredGroup: member.enteredGroup.toDateString() });
                   //als de membership kleiner is dan de huidig datum -> member is niet meer langer in de groep
                   if (new Date(member.membership) < new Date()) {
                       eventsArray.push({ ...member, membership: member.membership.toDateString(), date: member.membership.toDateString(), enteredGroup: member.enteredGroup.toDateString() });
                   }
               });
               eventsArray.sort((a, b) => {
                   return new Date(b.date) - new Date(a.date);
               });
               setEvents(eventsArray);
               evenstAlreadyRetrieved = true;
           }
       } catch (error) {
           document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML = "Something went wrong getting events of this group: " + error;
       }
    }

    function expenseItemOnClick(expenseId){
        window.location.href = `/insertExpense/${groupId}/${expenseId}`;
    }

    async function getGroupExpenses(groupId, currenUserId) {
    const getExprensesFromGroup = [];
    const getAllExpensesFromGroup = [];
       try {
           let getGroup = null;

           const q = doc(db, "Groups", groupId)

           const docSnap = await getDoc(q);
           if (docSnap.exists()) {
               // doc.data() is never undefined for query doc snapshots
               getGroup = docSnap.data();
           } else {
               // doc.data() will be undefined in this case
           }
           //krijg alle expenses van de group met bepaald groupId
           const expenses = await query(collection(db, "Groups", groupId, "Expenses"), where('isDeleted', '==', false));
           const expensesSnapshot = await getDocs(expenses);
           expensesSnapshot.forEach((doc) => {
               // doc.data() is never undefined for query doc snapshots
               getAllExpensesFromGroup.push({ ...doc.data(), key: doc.id }); // ... => spreidinsoperator
           });
           getAllExpensesFromGroup.forEach(expense => {
               //seconden omzetten naar een datum
               expense.date = new Date(expense.date.seconds * 1000).toDateString();
           });
           setAllExpenses(getAllExpensesFromGroup);

           getFilters(getAllExpensesFromGroup, currenUserId);

           //krijg de laatste expenses van de group met bepaald groupId
           const lastTenExpenses = await query(collection(db, "Groups", groupId, "Expenses"), where('isDeleted', '==', false), orderBy("date", "desc"), limit(10));
           const lastTenExpensesSnapshot = await getDocs(lastTenExpenses);
           lastTenExpensesSnapshot.forEach((doc) => {
               // doc.data() is never undefined for query doc snapshots
               getExprensesFromGroup.push({ ...doc.data(), key: doc.id }); // ... => spreidinsoperator 
           });
           getExprensesFromGroup.forEach(expense => {
               //seconden omzetten naar een datum
               expense.date = new Date(expense.date.seconds * 1000).toDateString();
           });

           calculateSpentWeekAndMonth(getExprensesFromGroup);
           setExpenses(getExprensesFromGroup);
           setTenExpenses(getExprensesFromGroup);
           setGroup(getGroup);
           getChartData(getAllExpensesFromGroup);
       } catch (error) {
           document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML ="Something went wrong getting expenses of this group: " + error;
       }
    }

    function selectClickedCategory(category) {
        
    }

    function resetFilter() {
        members.forEach(member => {
            member.selected = false;
        });
        categories.forEach(category => {
            category.selected = false;
        });
        setExpenses(tenExpense)
        calculateSpentWeekAndMonth(tenExpense);
    }


    function executeFilter( clickedPerson, clickedCategory , allExpensesGroup) {


        let selectedCategory;
        const filteredExpenses = [];
        const cateUpdate = [];
        const memberUpdate = [];


        categories.forEach(category => {
            if (category.label === clickedCategory) {
                category.selected = !category.selected;
            }
            cateUpdate.push(category);
        });
        setCategories(cateUpdate);


        members.forEach(member => {
            if (member.id === clickedPerson) {
                member.selected = !member.selected;
            }
            memberUpdate.push(member);
        });
        setMembers(memberUpdate);

        try {

        const selectedMem =[]
           members.forEach(member => {
              if (member.selected) {
                  selectedMem.push(member);
              }
           });
        const selectCate =[];
            cateUpdate.forEach(cate => {
                if (cate.selected) {
                    selectCate.push(cate);
                }
            });
            if (selectedMem.length === 0 && selectCate.length === 0) {
               tenExpense.forEach(expense => {
                     filteredExpenses.push({...expense, key: expense.key});
               });
           }
           else if (selectedMem.length === 0) {
               cateUpdate.forEach(category => {
                     if (category.selected) {
                          selectedCategory = category.label;

                             allExpensesGroup.forEach(expense => {
                                 if (expense.category === selectedCategory) {
                                     filteredExpenses.push({ ...expense, key: expense.key });
                                 }
                             });
                     }
               });
           }
           else{
                if (selectCate.length === 0) {
                    selectedMem.forEach(member => {
                        allExpensesGroup.forEach(expense => {
                            if (expense.owner === member.id) {
                                filteredExpenses.push({ ...expense, key: expense.key });
                            }
                        })
                    });
                }
                else{
                    selectCate.forEach(category => {
                            selectedCategory = category.label;

                            selectedMem.forEach(member => {
                                allExpensesGroup.forEach(expense => {
                                    if (expense.owner === member.id && expense.category === selectedCategory) {
                                        filteredExpenses.push({ ...expense, key: expense.key });
                                    }
                                })
                            });
                    });
                }
           }
        } catch (error) {
            document.getElementsByClassName('expensesMainErrorMessage')[0].innerHTML = "Something went wrong filtering expenses: " + error;
        }
        filteredExpenses.length = 10;
        calculateSpentWeekAndMonth(filteredExpenses);
        setExpenses(filteredExpenses);
    }
};

export default Expenses;